<template>
  <div class="card p-3 w-100 mb-2">
    <div class="w-100">
      <label>Professor</label>

      <div class="input-group" v-if="!user">
        <input
          v-model="search"
          class="form-control"
          placeholder="Buscar professor..."
        >
        <span class="input-group-append">
          <button class="input-group-text" @click="searchTeacher()">Buscar</button>
        </span>
      </div>
      <div v-else class="d-flex justify-content-between align-items-center border rounded p-2">
        <p class="mb-0">{{ user.name }}</p>
        <button class="btn btn-sm btn-danger" @click="changeTeacher()">
          <i class="fa fa-trash"></i>
        </button>
      </div>

      <table class="table table-striped table-sm table-responsive-md">
        <tbody>
          <list-teacher v-for="item in users.data" :key="item.id" :user="item" @teacherSelected="teacherSelected"/>
        </tbody>
      </table>
    </div>

    <p>Permissões</p>

    <div class="w-100 permissions mb-2">
      <div class="custom-control custom-checkbox">
        <input
          v-model="form.can_update_grade"
          type="checkbox"
          class="custom-control-input"
          :id="`can_update_grade_${uuid}`"
        >
        <label
          class="custom-control-label"
          :for="`can_update_grade_${uuid}`"
        >Alterar Grade</label>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`can_see_doubts_${uuid}`"
          v-model="form.can_see_doubts"
        >
        <label
          class="custom-control-label"
          :for="`can_see_doubts_${uuid}`"
        >Ver Dúvidas</label>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`can_respond_doubts_${uuid}`"
          v-model="form.can_respond_doubts"
        >
        <label
          class="custom-control-label"
          :for="`can_respond_doubts_${uuid}`"
        >Responder Dúvidas</label>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`can_edit_infos_${uuid}`"
          v-model="form.can_edit_infos"
        >
        <label
          class="custom-control-label"
          :for="`can_edit_infos_${uuid}`"
        >Editar Informações</label>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          v-model="form.can_edit_payments"
          type="checkbox"
          class="custom-control-input"
          :id="`can_edit_payments_${uuid}`"
        >
        <label
          class="custom-control-label"
          :for="`can_edit_payments_${uuid}`"
        >Editar Pagamentos</label>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`can_edit_medias_${uuid}`"
          v-model="form.can_edit_medias"
        >
        <label
          class="custom-control-label"
          :for="`can_edit_medias_${uuid}`"
        >Editar Midias</label>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`can_edit_teachers_${uuid}`"
          v-model="form.can_edit_teachers"
        >
        <label
          class="custom-control-label"
          :for="`can_edit_teachers_${uuid}`"
        >Editar Professores</label>
      </div>

      <div class="custom-control custom-checkbox">
        <input
          type="checkbox"
          class="custom-control-input"
          :id="`certificate_emitter_${uuid}`"
          v-model="form.certificate_emitter"
        >
        <label
          class="custom-control-label"
          :for="`certificate_emitter_${uuid}`"
        >Aparecer no Certificado</label>
      </div>
    </div>

    <div class="d-flex justify-content-end">
      <button v-if="form.id != undefined" class="btn btn-sm btn-danger mr-1" @click="remove()">Deletar</button>
      <button v-else class="btn btn-sm btn-danger mr-1" @click="reset()">Cancelar</button>
      <button class="btn btn-sm btn-success" @click="save()">Salvar Professor</button>
    </div>
  </div>
</template>

<script>
import Axios from 'axios'
import Swal from 'sweetalert2'
import { Form, HasError } from 'vform'
import ListTeacher from './ListTeacher'
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    "list-teacher": ListTeacher
  },
  props: {
    teacher: {
      required: false
    },
    course: {
      required: true
    }
  },
  data() {
    return {
      search: '',
      user: undefined,
      users: [],
      showing: false,
      editing: false,
      uuid: undefined,
      form: new Form({
        id: undefined,
        course_id: this.course,
        user_id: undefined,
        can_update_grade: false,
        can_see_doubts: false,
        can_respond_doubts: false,
        can_edit_infos: false,
        can_edit_payments: false,
        can_edit_medias: false,
        can_edit_teachers: false,
        certificate_emitter: false,
        was_accepted: false,
        is_actived: true,
      })
    }
  },
  methods: {
    searchTeacher: function() {
      Axios.get('/user/teacher', {
        params: {
          search: this.search
        }
      })
        .then( res => {
          this.users = res.data
        })
    },

    teacherSelected: function(event) {
      this.user = event;
      this.form.user_id = event.id;
      this.users = [];
      this.search = "";
    },

    changeTeacher: function() {
      this.user = undefined
      this.form.user_id = undefined;
    },

    reset: function() {
      if(this.editing) return
      this.search = '';
      this.user = undefined;
      this.form.reset();
    },

    save: function() {
      this.editing = this.form.id != undefined;
      this.form.course_id = this.course
      this.form.post('/teacher/course/teacher')
        .then( res => {
          this.reset()
          this.$emit('reloadTeachers')
        })
    },

    remove: function() {
      Axios.delete(`/teacher/course/teacher/${this.form.id}`)
        .then( res => {
          this.$emit('reloadTeachers')
        })
    },

    toggleShowing: function() {
      this.showing = !this.showing
    }
  },
  mounted () {
    this.uuid = uuidv4();
    if(this.teacher) {
      this.form.fill(this.teacher);
      this.user = this.teacher.user;
    }
  }
}
</script>

<style scoped>
  .permissions {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  }
</style>
